export enum StepStates {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  OTHER = 'OTHER',
}
